import React from 'react';
import { DateFormat } from '@ui-library/pickers/DateFormat';
import { Subtext, H3 } from '@ui-library/typography';
import { Flex } from '@ui-library/misc';
import RadioGroup from '@ui-library/radio';
import radioStyles from '@components/workflows/steps/selectTransformation/selectTransformation.module.scss';
import Button from '@ui-library/button';
import useModalView from '@hooks/useModalView';
import Modal from '@ui-library/modal/custom';
import { RadioChangeEvent } from 'antd';
import classes from './accountCredentials.module.scss';

interface Props {
  accounts: { id: string; name: string; metadata?: { email: string }; createdAt: string }[];
  onSelect: (id: string) => void;
  selectedAccount: string;
  onDelete: (id: string) => void;
  isDeleteInProgress: boolean;
  disabled?: boolean;
}

export default ({
  accounts,
  disabled,
  onSelect,
  selectedAccount,
  onDelete,
  isDeleteInProgress,
}: Props) => {
  const handleDelete = async () => {
    await onDelete(selectedAccount);
    showDeleteModal(false);
  };

  const [deleteModal, showDeleteModal] = useModalView(
    <Modal
      title="Delete Account"
      onSave={handleDelete}
      onClose={() => showDeleteModal(false)}
      size="sm"
      saveLabel="Confirm"
      content="Are you sure you want to remove this account?"
      loading={isDeleteInProgress}
    />,
  );

  const onChange = (e: RadioChangeEvent) => {
    const { value } = e.target;
    onSelect(value);
  };

  return (
    <>
      {deleteModal}
      <Flex justifyContent="space-between" className={classes.header}>
        <H3>Choose an account</H3>
        {selectedAccount && accounts.length > 1 && !disabled && (
          <Button deletePrimary name="Delete" onClick={() => showDeleteModal(true)} />
        )}
      </Flex>
      <div className={classes.list}>
        <Flex alignItems="center">
          <RadioGroup
            disabled={disabled}
            onChange={onChange}
            className={radioStyles.existing_items}
            value={selectedAccount}
            items={accounts.map((acc) => ({
              id: acc.id,
              element: (
                <Flex flexDirection="column">
                  <Subtext>{acc.name}</Subtext>
                  <Subtext>{acc.metadata?.email}</Subtext>
                  <Subtext>
                    <>
                      <span>Created at </span>
                      <DateFormat date={acc.createdAt} format="DD MMM yyyy" />
                    </>
                  </Subtext>
                </Flex>
              ),
              className: `${radioStyles.item}  ${
                selectedAccount === acc.id ? radioStyles.selected : ''
              }`,
            }))}
          />
        </Flex>
      </div>
    </>
  );
};
